<template>
  <section>
    <gs-header title="Chi tiết đối soát" :breadcrumbs="[
      { title: 'Phiên đối soát', route: { name: 'compare' } }
    ]">
      <el-popover ref="applyPopup" placement="top" width="200" v-model="applyPopup">
        <p>Bạn xác nhận đối soát này?</p>
        <div style="text-align: center; margin: 0">
          <el-button size="small" @click="applyPopup = false">Không</el-button>
          <el-button size="small" type="primary" :disabled="applyCompareSubmitting" :loading="applyCompareSubmitting"
            @click.prevent="applyCompare">Xác
            nhận</el-button>
        </div>
      </el-popover>
      <el-popover ref="removePopup" placement="top" width="200" v-model="removePopup">
        <p>Bạn xác nhận hủy đối soát này?</p>
        <div style="text-align: center; margin: 0">
          <el-button size="small" @click="removePopup = false">Không</el-button>
          <el-button size="small" type="primary" @click.prevent="removeCompare">Xác nhận</el-button>
        </div>
      </el-popover>
      <el-button size="small" type="success" v-popover:applyPopup @click="applyPopup = !applyPopup" v-if="canEdit" icon="el-icon-finished">Xác nhận
        đối
        soát</el-button>
      <el-button size="small" type="warning" icon="el-icon-check" v-if="canEdit" @click="verifyCrossCheck">Duyệt đối
        soát</el-button>
      <el-button size="small" type="danger" v-popover:removePopup @click="removePopup = !removePopup" v-if="canEdit" icon="el-icon-remove">Hủy đối
        soát</el-button>
      <el-button size="small" v-if="canEdit" @click="addShipmentModal = !addShipmentModal" icon="el-icon-plus">Thêm vận
        đơn</el-button>
      <el-button type="text" @click="exportExcel" icon="el-icon-download">Xuất
        excel</el-button>
    </gs-header>
    <div class="padding-sm-all">
      <el-row class="padding-all" :gutter="10">
        <el-col :span="8">
          <el-descriptions class="margin-top" title="Tổng quan" :column="2" border>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-collection-tag"></i>
                Đơn thành công
              </template>
              {{ crossChecks.num_compare_success | number }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-warning-outline"></i>
                Đơn lỗi
              </template>
              <span class="text-red">{{ crossChecks.num_compare_error | number }}</span>
            </el-descriptions-item>
            <el-descriptions-item v-if="getCrossCheckKind(CROSS_CHECK_TYPE.COD)">
              <template slot="label">
                <i class="el-icon-money"></i>
                COD hãng thu
              </template>
              {{ crossChecks.cod_carrier | vnd }}
            </el-descriptions-item>
            <el-descriptions-item v-if="getCrossCheckKind(CROSS_CHECK_TYPE.COD)">
              <template slot="label">
                <i class="el-icon-coin"></i>
                COD hãng trả
              </template>
              {{ crossChecks.cod_goship | vnd }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-money"></i>
                {{ getCrossCheckKind(CROSS_CHECK_TYPE.COD) ? 'Tổng phí thu' : 'Tổng phí đối soát lần 1' }}
              </template>
              {{ crossChecks.fee_goship | vnd }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-coin"></i>
                {{ getCrossCheckKind(CROSS_CHECK_TYPE.COD) ? 'Tổng phí trả' : 'Tổng phí đối soát' }}
              </template>
              {{ crossChecks.fee_carrier | vnd }}
            </el-descriptions-item>
          </el-descriptions>
        </el-col>
        <el-col :span="16" v-if="getCrossCheckKind(CROSS_CHECK_TYPE.COD)">
          <h3 style="margin: 15px 0">COD trả shop</h3>
          <el-table :data="financeReport" border style="width: 100%; height: 100%" stripe>
            <el-table-column label="Hãng vận chuyển" prop="carrier" />
            <el-table-column label="Tổng COD" prop="cod" />
            <el-table-column label="Tiền phí" prop="fee" />
            <el-table-column label="Tiền phải trả" prop="total_pay" />
          </el-table>
        </el-col>
      </el-row>

      <template v-if="typeofCompare">
        <gs-table :cache-data="false" :ref="listtingCompareTable" :table-name="listtingCompareTable"
          :data-source="typeofCompare + this.$route.params.id" :data-params="filters" :data-sorted="sorted"
          :data-sorts="sorts" @remove-filter="removeFilter">
          <section slot="filters" style="margin-bottom: 24px;">
            <el-row :gutter="20">
              <!-- <el-col :span="24">
              <el-radio-group class="status-listting" v-model="filters.status" v-if="compareHelpers.statuses"
                :fill="listtingComparesStatusBg[filters.status]" @change="filter">
                <el-radio-button :label="index" v-for="(status, index) in compareHelpers.statuses" :key="index">
                  <el-tooltip placement="top" content="Trạng thái" class="display-inline">
                    <span :class="{ [listtingComparesStatus[index]]: filters.status !== index }">{{ status }}</span>
                  </el-tooltip>
                </el-radio-button>
                <el-radio-button :label="-1">
                  <el-tooltip placement="top" content="Trạng thái" class="display-inline">
                    <span :class="{ [listtingComparesStatus[-1]]: filters.status !== -1 }">Tất cả</span>
                  </el-tooltip>
                </el-radio-button>
              </el-radio-group>
            </el-col> -->
            <el-col :span="24">
              <el-radio-group class="status-listting" v-model="filters.error_id" v-if="compareHelpers.errors && getCrossCheckKind(CROSS_CHECK_TYPE.COD)"
                :fill="listtingComparesErrorBg[filters.error_id]" @change="filter">
                <el-radio-button :label="index" v-for="(error, index) in compareHelpers.errors" :key="index">
                  &bullet; {{
                    error
                  }} <span :class="{ [listtingComparesError[index]]: filters.error_id !== index }">({{
  countErrorCompare(index) }})</span>
                </el-radio-button>
                <el-radio-button :label="-1">
                  &bullet; <span :class="{ [listtingComparesError[-1]]: filters.error_id !== -1 }">Tất cả</span>
                </el-radio-button>
              </el-radio-group>
              <el-radio-group class="status-listting" v-model="filters.error_id" v-if="compareFeeHelpers.errors && getCrossCheckKind(CROSS_CHECK_TYPE.FEE)"
                :fill="listtingComparesErrorBg[filters.error_id]" @change="filter">
                <el-radio-button :label="index" v-for="(error, index) in compareFeeHelpers.errors" :key="index">
                  &bullet; {{
                    error
                  }} <span :class="{ [listtingComparesError[index]]: filters.error_id !== index }">({{
  countErrorCompare(index) }})</span>
                </el-radio-button>
                <el-radio-button :label="-1">
                  &bullet; <span :class="{ [listtingComparesError[-1]]: filters.error_id !== -1 }">Tất cả</span>
                </el-radio-button>
              </el-radio-group>
              <el-radio-group class="status-listting" v-model="filters.error_id" v-if="compareHelpers.errors_fee_1 && getCrossCheckKind(CROSS_CHECK_TYPE.FEE1)"
                :fill="listtingComparesErrorBg[filters.error_id]" @change="filter">
                <el-radio-button :label="index" v-for="(error, index) in compareHelpers.errors_fee_1" :key="index">
                  &bullet; {{
                    error
                  }} <span :class="{ [listtingComparesError[index]]: filters.error_id !== index }">({{
  countErrorCompare(index) }})</span>
                </el-radio-button>
                <el-radio-button :label="-1">
                  &bullet; <span :class="{ [listtingComparesError[-1]]: filters.error_id !== -1 }">Tất cả</span>
                </el-radio-button>
              </el-radio-group>

            </el-col>
          </el-row>
        </section>
        <section slot="inline-filters" style="display: flex; flex-wrap: wrap">
          <el-popover ref="removeErrorShipmentPopup" placement="top" width="200" v-model="removeErrorShipmentPopup">
            <p v-if="filters.error_id">Xoá tất cả vận đơn: <code class="text-red">{{
              getErrorText()
            }}</code> ?
            </p>
            <div style="text-align: right; margin: 0">
              <el-button size="small" @click="removeErrorShipmentPopup = false">Không</el-button>
              <el-button type="primary" size="small" :disabled="removeErrorShipmentSubmitting"
                @click.prevent="removeAllErrorShipment">Xác
                nhận</el-button>
            </div>
          </el-popover>
          <el-button type="primary" size="small" v-if="filters.error_id != -1" @click="removeErrorShipmentPopup = !removeErrorShipmentPopup" v-popover:removeErrorShipmentPopup><i
              class="fa fa-trash"></i> Xoá tất cả</el-button>
          <el-button type="primary" size="small" v-if="filters.error_id == 1" :disabled="countErrorCompare(1) === 0" @click="resyncCode"><i
              class="fa fa-refresh"></i> Đồng bộ
            code</el-button>
          <el-button type="primary" size="small" v-if="filters.error_id != -1" @click="exportExcelCompare"><i
            class="fa fa-download"></i> Xuất excel
          </el-button>
          <el-button type="primary" size="small" v-if="filters.error_id == 3" :disabled="countErrorCompare(3) === 0" @click="resyncCode"><i
            class="fa fa-refresh"></i> Đồng bộ đối soát
          </el-button>
          <el-button type="primary" size="small" v-if="filters.error_id == 6" :disabled="countErrorCompare(6) === 0" @click="updateWeight"><i
              class="fa fa-refresh"></i> Đồng bộ
            cân</el-button>
          <el-button type="primary" size="small" v-if="filters.error_id == 5 || filters.error_id == 7" :disabled="filters.error_id == 5 ? countErrorCompare(5) === 0 : countErrorCompare(7) === 0" @click="updateFeeCarrier"><i
            class="fa fa-refresh"></i> Cập nhật theo phí hãng
          </el-button>
        </section>

          <template slot-scope="datas">
            <el-table v-if="getCrossCheckKind(CROSS_CHECK_TYPE.COD)" :data="datas.data" border style="width: 100%">
              <el-table-column label="#" width="50" align="center">
                <template slot-scope="scope">
                  <small v-if="dataPaginations[listtingCompareTable]">{{ (scope.$index + 1) +
                    ((dataPaginations[listtingCompareTable].current_page - 1) *
                      dataPaginations[listtingCompareTable].per_page)
                  }}</small>
                </template>
              </el-table-column>

              <el-table-column label="Đối Soát" width="200">
                <template slot-scope="scope">
                  <p v-if="scope.row.shipment" :class="shipmentStatuses[scope.row.shipment.data.status]">
                    <el-tooltip placement="top" content="Trạng thái vận đơn" class="display-inline">
                      <span><i aria-hidden="true" class="fa fa-file-text-o"></i> {{ scope.row.shipment.data.status_txt
                        }}
                        <small v-if="scope.row.shipment.data.is_return">(Chuyển hoàn)</small><small
                          v-if="scope.row.shipment.data.is_part_delivery">(Giao một phần)</small><small
                          v-if="scope.row.shipment.data.is_lost">(Thất lạc)</small></span>
                    </el-tooltip>
                  </p>
                  <p :class="listtingComparesStatus[scope.row.status]">
                    <el-tooltip placement="top" content="Trạng thái" class="display-inline">
                      <span><i aria-hidden="true" class="fa fa-info-circle"></i> {{ scope.row.status_txt }}</span>
                    </el-tooltip>
                  </p>
                  <p class="text-red">
                    <el-tooltip placement="top" content="Trạng thái lỗi" class="display-inline">
                      <span><i aria-hidden="true" class="fa fa-exclamation-circle"></i> {{ scope.row.error_txt }}</span>
                    </el-tooltip>
                  </p>
                  <p>
                    <el-tooltip placement="top" content="Ngày tạo" class="display-inline">
                      <span><i aria-hidden="true" class="fa fa-clock-o"></i> {{ scope.row.created_at }}</span>
                    </el-tooltip>
                  </p>
                </template>
              </el-table-column>

              <el-table-column label="">
                <template slot-scope="scope">
                  <p v-if="scope.row.shipment"><span>Mã vận đơn: </span><span class="shipment-code-display click-copy"
                      v-if="scope.row.shipment">{{ scope.row.shipment.data.id }}</span></p>
                  <p v-if="scope.row.shipment"><span>Mã đơn HVC: </span> <span
                      class="shipment-code-display click-copy">{{
                        scope.row.code
                      }}</span></p>
                  <!-- <p v-if="scope.row.shipment"><span>Trạng thái vận đơn: </span> <span :class="shipmentStatuses[scope.row.shipment.data.status]">{{scope.row.shipment.data.status_txt}} <small v-if="scope.row.shipment.data.is_return">(Chuyển hoàn)</small><small v-if="scope.row.shipment.data.is_part_delivery">(Giao một phần)</small><small v-if="scope.row.shipment.data.is_lost">(Thất lạc)</small></span></p> -->
                  <p v-if="scope.row.shipment && scope.row.shipment.data.invoice"><span>Mã phiếu chi: </span> <span
                      class="shipment-code-display click-copy">{{
                        scope.row.shipment.data.invoice.data.id }}</span></p>
                </template>
              </el-table-column>

              <el-table-column label="Thông Tin Khách Hàng">
                <template slot-scope="scope">
                  <p v-if="scope.row.shipment && scope.row.client"><i class="fa fa-user"></i>&nbsp;{{
                    scope.row.client.data.name
                    }}</p>
                  <p v-if="scope.row.shipment && scope.row.client"><i class="fa fa-mobile"></i>&nbsp;<span
                      class="click-copy">{{ scope.row.client.data.phone }}</span></p>
                  <p v-if="scope.row.shipment && scope.row.client"><i class="fa fa-envelope-o"
                      aria-hidden="true"></i>&nbsp;<span class="click-copy">{{ scope.row.client.data.email }}</span></p>
                </template>
              </el-table-column>

            <el-table-column label="">
              <template slot-scope="scope">
                <p>Tiền thu hộ (COD)</p>
                <p>Tổng phí</p>
                <p>Đã thu</p>
                <p>Cần thu</p>
                <p>Cân nặng</p>
              </template>
            </el-table-column>

            <el-table-column label="Thông Tin Đối Soát">
              <template slot-scope="scope">
                <div>
                  <p class="text-right click-copy text-red">{{ scope.row.cod_amount | vnd }}</p>
                  <p class="text-right click-copy text-red">{{ scope.row.total_fee + scope.row.last_total_fee | vnd }}</p>
                  <p class="text-right click-copy text-red">{{ scope.row.last_total_fee | vnd }}</p>
                  <p class="text-right click-copy text-red">{{ scope.row.total_fee | vnd }}</p>
                  <p class="text-right click-copy text-red">{{ scope.row.weight | gam }}</p>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="Thông Tin Vận Đơn">
              <template slot-scope="scope">
                <div>
                  <p v-if="scope.row.shipment" class="click-copy text-red">{{ scope.row.shipment.data.amount_for_cross | vnd}}</p>
                  <p v-if="scope.row.shipment" class="click-copy text-red">{{ scope.row.shipment.data.total_fee | vnd }}</p>
                  <p v-if="scope.row.shipment" class="click-copy text-red">{{ scope.row.last_payed_fee | vnd }}</p>
                  <p v-if="scope.row.shipment" class="click-copy text-red">{{ scope.row.shipment.data.total_fee - scope.row.last_payed_fee | vnd }}</p>
                </div>
                <p v-if="scope.row.parcel" class="click-copy text-red">{{ isOverweight(scope)
                  | gam
                }}</p>
              </template>
            </el-table-column>
            <el-table-column label="Thông tin tài chính">
              <template slot-scope="scope">
                <div>
                  <p v-if="scope.row.shipment">Doanh thu: <span class="pull-right click-copy text-red">{{
                    scope.row.shipment.data.total_fee | vnd
                  }}</span></p>
                  <p v-if="scope.row.shipment">Chi phí: <span class="pull-right click-copy text-red">{{
                    scope.row.total_fee + scope.row.last_total_fee | vnd
                  }}</span></p>
                  <p v-if="scope.row.shipment">Lợi nhuận: <span class="pull-right click-copy text-red">{{
                    scope.row.shipment.data.total_fee - scope.row.total_fee - scope.row.last_total_fee |
                    vnd
                  }}</span></p>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="50">
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <el-tooltip placement="top" content="Sửa" class="display-inline">
                    <a class="text-orange padding-all display-inline-block cursor-pointer"
                      @click="editListtingCompare(scope.row)"><i class="fa fa-pencil-square-o"></i></a>
                  </el-tooltip>
                  <el-tooltip v-if="scope.row.shipment && scope.row.shipment.data.can_hard_update && isCheckUpgrade" placement="top" content="Cập nhập thông tin" class="display-inline">
                    <a class="text-brown padding-all display-inline-block cursor-pointer" @click="showEditShipment(scope.row.shipment)"><i class="fa fa-pencil"></i></a>
                  </el-tooltip>
                  <el-tooltip v-if="scope.row.error" placement="top" content="Xóa" class="display-inline">
                    <a class="text-red padding-all display-inline-block cursor-pointer"
                      @click="deleteListtingCompare(scope.row)"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>

          <el-table v-if="getCrossCheckKind(CROSS_CHECK_TYPE.FEE)" :data="datas.data" border style="width: 100%">
            <el-table-column label="#" width="50" align="center">
              <template slot-scope="scope">
                <small v-if="dataPaginations[listtingCompareTable]">{{ (scope.$index + 1) +
                  ((dataPaginations[listtingCompareTable].current_page - 1) *
                    dataPaginations[listtingCompareTable].per_page)
                }}</small>
              </template>
            </el-table-column>

            <el-table-column label="Đối Soát" width="200">
              <template slot-scope="scope">
                <p v-if="scope.row.shipment" :class="shipmentStatuses[scope.row.shipment.data.status]">
                  <el-tooltip placement="top" content="Trạng thái vận đơn" class="display-inline">
                    <span><i aria-hidden="true" class="fa fa-file-text-o"></i> {{ scope.row.shipment.data.status_txt }}
                      <small v-if="scope.row.shipment.data.is_return">(Chuyển hoàn)</small><small
                        v-if="scope.row.shipment.data.is_part_delivery">(Giao một phần)</small><small
                        v-if="scope.row.shipment.data.is_lost">(Thất lạc)</small></span>
                  </el-tooltip>
                </p>
                <p :class="listtingComparesStatus[scope.row.status]">
                  <el-tooltip placement="top" content="Trạng thái" class="display-inline">
                    <span><i aria-hidden="true" class="fa fa-info-circle"></i> {{ scope.row.status_txt }}</span>
                  </el-tooltip>
                </p>
                <p class="text-red">
                  <el-tooltip placement="top" content="Trạng thái lỗi" class="display-inline">
                    <span><i aria-hidden="true" class="fa fa-exclamation-circle"></i> {{ scope.row.error_txt }}</span>
                  </el-tooltip>
                </p>
                <p>
                  <el-tooltip placement="top" content="Ngày tạo" class="display-inline">
                    <span><i aria-hidden="true" class="fa fa-clock-o"></i> {{ scope.row.created_at }}</span>
                  </el-tooltip>
                </p>
              </template>
            </el-table-column>

            <el-table-column label="">
              <template slot-scope="scope">
                <p v-if="scope.row.shipment"><span>Mã vận đơn: </span><span class="shipment-code-display click-copy"
                    v-if="scope.row.shipment">{{ scope.row.shipment.data.id }}</span></p>
                <p v-if="scope.row.shipment"><span>Mã đơn HVC: </span> <span class="shipment-code-display click-copy">{{
                  scope.row.code
                }}</span></p>
                <!-- <p v-if="scope.row.shipment"><span>Trạng thái vận đơn: </span> <span :class="shipmentStatuses[scope.row.shipment.data.status]">{{scope.row.shipment.data.status_txt}} <small v-if="scope.row.shipment.data.is_return">(Chuyển hoàn)</small><small v-if="scope.row.shipment.data.is_part_delivery">(Giao một phần)</small><small v-if="scope.row.shipment.data.is_lost">(Thất lạc)</small></span></p> -->
                <p v-if="scope.row.shipment && scope.row.shipment.data.invoice_fee"><span>Mã phiếu chi: </span> <span class="shipment-code-display click-copy">{{
                  scope.row.shipment.data.invoice_fee.data.id }}</span></p>
              </template>
            </el-table-column>

            <el-table-column label="Thông Tin Khách Hàng">
              <template slot-scope="scope">
                <p v-if="scope.row.shipment && scope.row.client"><i class="fa fa-user"></i>&nbsp;{{
                  scope.row.client.data.name
                }}</p>
                <p v-if="scope.row.shipment && scope.row.client"><i class="fa fa-mobile"></i>&nbsp;<span
                    class="click-copy">{{ scope.row.client.data.phone }}</span></p>
                <p v-if="scope.row.shipment && scope.row.client"><i class="fa fa-envelope-o"
                    aria-hidden="true"></i>&nbsp;<span class="click-copy">{{ scope.row.client.data.email }}</span></p>
              </template>
            </el-table-column>

            <el-table-column label="">
              <template slot-scope="scope">
                <p>Tổng phí</p>
              </template>
            </el-table-column>

            <el-table-column label="Thông Tin Đối Soát Lần 1">
              <template slot-scope="scope">
                <div>
                  <p class="text-right click-copy text-red">{{ scope.row.last_total_fee | vnd }}</p>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="Thông Tin Đối Soát">
              <template slot-scope="scope">
                <div>
                  <p class="text-right click-copy text-red">{{ scope.row.total_fee | vnd }}</p>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="Chênh lệch">
              <template slot-scope="scope">
                <p><span class="text-red">{{ differenceFee(scope.row.last_total_fee, scope.row.total_fee) | vnd }}</span></p>
              </template>
            </el-table-column>

            <el-table-column label="Thông Tin Vận Đơn">
              <template slot-scope="scope">
                <p v-if="scope.row.shipment" class="click-copy text-red">{{ scope.row.shipment.data.total_fee | vnd }}</p>
              </template>
            </el-table-column>

            <el-table-column width="50">
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <el-tooltip placement="top" content="Sửa" class="display-inline">
                    <a class="text-orange padding-all display-inline-block cursor-pointer"
                      @click="editListtingCompare(scope.row)"><i class="fa fa-pencil-square-o"></i></a>
                  </el-tooltip>
                  <el-tooltip v-if="scope.row.shipment && scope.row.shipment.data.can_hard_update && isCheckUpgrade" placement="top" content="Cập nhập thông tin" class="display-inline">
                    <a class="text-brown padding-all display-inline-block cursor-pointer" @click="showEditShipment(scope.row.shipment)"><i class="fa fa-pencil"></i></a>
                  </el-tooltip>
                  <el-tooltip v-if="scope.row.error" placement="top" content="Xóa" class="display-inline">
                    <a class="text-red padding-all display-inline-block cursor-pointer"
                      @click="deleteListtingCompare(scope.row)"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>

          <el-table v-if="getCrossCheckKind(CROSS_CHECK_TYPE.FEE1)" :data="datas.data" border style="width: 100%">
            <el-table-column label="#" width="50" align="center">
              <template slot-scope="scope">
                <small v-if="dataPaginations[listtingCompareTable]">{{ (scope.$index + 1) +
                  ((dataPaginations[listtingCompareTable].current_page - 1) *
                    dataPaginations[listtingCompareTable].per_page)
                }}</small>
              </template>
            </el-table-column>

            <el-table-column label="Đối Soát" width="200">
              <template slot-scope="scope">
                <p v-if="scope.row.shipment" :class="shipmentStatuses[scope.row.shipment.data.status]">
                  <el-tooltip placement="top" content="Trạng thái vận đơn" class="display-inline">
                    <span><i aria-hidden="true" class="fa fa-file-text-o"></i> {{ scope.row.shipment.data.status_txt }}
                      <small v-if="scope.row.shipment.data.is_return">(Chuyển hoàn)</small><small
                        v-if="scope.row.shipment.data.is_part_delivery">(Giao một phần)</small><small
                        v-if="scope.row.shipment.data.is_lost">(Thất lạc)</small></span>
                  </el-tooltip>
                </p>
                <p :class="listtingComparesStatus[scope.row.status]">
                  <el-tooltip placement="top" content="Trạng thái" class="display-inline">
                    <span><i aria-hidden="true" class="fa fa-info-circle"></i> {{ scope.row.status_txt }}</span>
                  </el-tooltip>
                </p>
                <p class="text-red">
                  <el-tooltip placement="top" content="Trạng thái lỗi" class="display-inline">
                    <span><i aria-hidden="true" class="fa fa-exclamation-circle"></i> {{ scope.row.error_txt }}</span>
                  </el-tooltip>
                </p>
                <p>
                  <el-tooltip placement="top" content="Ngày tạo" class="display-inline">
                    <span><i aria-hidden="true" class="fa fa-clock-o"></i> {{ scope.row.created_at }}</span>
                  </el-tooltip>
                </p>
              </template>
            </el-table-column>

            <el-table-column label="">
              <template slot-scope="scope">
                <p v-if="scope.row.shipment"><span>Mã vận đơn: </span><span class="shipment-code-display click-copy"
                    v-if="scope.row.shipment">{{ scope.row.shipment.data.id }}</span></p>
                <p v-if="scope.row.shipment"><span>Mã đơn HVC: </span> <span class="shipment-code-display click-copy">{{
                  scope.row.code
                }}</span></p>
                <!-- <p v-if="scope.row.shipment"><span>Trạng thái vận đơn: </span> <span :class="shipmentStatuses[scope.row.shipment.data.status]">{{scope.row.shipment.data.status_txt}} <small v-if="scope.row.shipment.data.is_return">(Chuyển hoàn)</small><small v-if="scope.row.shipment.data.is_part_delivery">(Giao một phần)</small><small v-if="scope.row.shipment.data.is_lost">(Thất lạc)</small></span></p> -->
                <p v-if="scope.row.shipment && scope.row.shipment.data.invoice"><span>Mã phiếu chi: </span> <span class="shipment-code-display click-copy">{{
                  scope.row.shipment.data.invoice.data.id }}</span></p>
              </template>
            </el-table-column>

            <el-table-column label="Thông Tin Khách Hàng">
              <template slot-scope="scope">
                <p v-if="scope.row.shipment && scope.row.client"><i class="fa fa-user"></i>&nbsp;{{
                  scope.row.client.data.name
                }}</p>
                <p v-if="scope.row.shipment && scope.row.client"><i class="fa fa-mobile"></i>&nbsp;<span
                    class="click-copy">{{ scope.row.client.data.phone }}</span></p>
                <p v-if="scope.row.shipment && scope.row.client"><i class="fa fa-envelope-o"
                    aria-hidden="true"></i>&nbsp;<span class="click-copy">{{ scope.row.client.data.email }}</span></p>
              </template>
            </el-table-column>

            <el-table-column label="">
              <template slot-scope="scope">
                <p>Tổng phí</p>
                <p>Đã thu</p>
                <p>Cần thu</p>
              </template>
            </el-table-column>

            <el-table-column label="Thông Tin Đối Soát">
              <template slot-scope="scope">
                <div>
                  <p class="text-right click-copy text-red">{{ scope.row.total_fee + scope.row.last_total_fee | vnd }}</p>
                  <p class="text-right click-copy text-red">{{ scope.row.last_total_fee | vnd }}</p>
                  <p class="text-right click-copy text-red">{{ scope.row.total_fee | vnd }}</p>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="Thông Tin Vận Đơn">
              <template slot-scope="scope">
                <div>
                  <p v-if="scope.row.shipment" class="click-copy text-red">{{ scope.row.shipment.data.total_fee | vnd }}</p>
                  <p v-if="scope.row.shipment" class="click-copy text-red">{{ scope.row.last_payed_fee | vnd }}</p>
                  <p v-if="scope.row.shipment" class="click-copy text-red">{{ scope.row.shipment.data.total_fee - scope.row.last_payed_fee | vnd }}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="50">
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <el-tooltip placement="top" content="Sửa" class="display-inline">
                    <a class="text-orange padding-all display-inline-block cursor-pointer"
                      @click="editListtingCompare(scope.row)"><i class="fa fa-pencil-square-o"></i></a>
                  </el-tooltip>
                  <el-tooltip v-if="scope.row.shipment && scope.row.shipment.data.can_hard_update && isCheckUpgrade" placement="top" content="Cập nhập thông tin" class="display-inline">
                    <a class="text-brown padding-all display-inline-block cursor-pointer" @click="showEditShipment(scope.row.shipment)"><i class="fa fa-pencil"></i></a>
                  </el-tooltip>
                  <el-tooltip v-if="scope.row.error" placement="top" content="Xóa" class="display-inline">
                    <a class="text-red padding-all display-inline-block cursor-pointer"
                      @click="deleteListtingCompare(scope.row)"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>

        </template>
      </gs-table>
      </template>
      <!-- EDIT COMPARE DIALOG -->
      <el-dialog :title="'Sửa đối soát:: ' + currentListtingCompare.code" :visible.sync="editModal">
        <el-form :model="currentListtingCompare" ref="editListtingCompare" label-width="200px" label-position="top"
          @submit.prevent.native="validateBeforeSubmitEditCompare('editListtingCompare')">
          <el-row :gutter="20">
            <el-col :span="24" v-if="getCrossCheckKind(CROSS_CHECK_TYPE.COD)">
              <el-form-item label="Tiền thu hộ (COD)">
                <el-input v-model="currentListtingCompare.cod_amount" placeholder=""></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Tổng phí">
                <el-input v-model="currentListtingCompare.total_fee" placeholder="Tổng phí"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="getCrossCheckKind(CROSS_CHECK_TYPE.COD)">
              <el-form-item label="Cân nặng">
                <el-input v-model="currentListtingCompare.weight" placeholder="Cân nặng"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item>
            <button class="ui blue basic small button" :disable="submitting" native-type="submit">Lưu lại</button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>

    <!-- ADD SHIPMENT DIALOG -->
    <dialog-add-shipment-to-compare v-model="addShipmentModal" @success="reloadDataListCompare"
      :type="crossChecks.kind" />

    <!-- UPGRADE SHIPMENT -->
    <el-dialog @close="closeModalShipment" :title="`Cập nhật thông tin vận đơn: ${localShipment.code}`"
      :visible.sync="editShipmentModal" width="100%">
      <upgrade-shipment v-if="localShipment.id" :shipment-id="localShipment.id"
        @edit-shipment-success="editShipmentSuccess"></upgrade-shipment>
    </el-dialog>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { debounce, head, keys, forEach } from 'lodash'
import ls from 'local-storage'
import { updateCompare, updateCompareFee, ApplyCrossCheck, DeleteCrossCheck, exportExcel, exportExcelFee, getCrossCheck, deleteCompare, deleteCompareFee, removeErrorShipment, resyncingCode, updateWeight, verifyCrossCheck, updateFeeByCarrier } from 'src/api/compares'
import { listtingComparesStatus, listtingComparesStatusBg, listtingComparesError, listtingComparesErrorBg } from 'src/stubs/compares'
import { shipmentStatuses } from 'src/stubs/shipments'
import DialogAddShipmentToCompare from './DialogAddShipmentToCompare.vue'
import UpgradeShipment from './UpgradeShipment'
import * as XLSX from 'xlsx'
import { getFromUrl } from 'src/api'
import { CROSS_CHECK_TYPE } from "src/constants";
import { vnd } from "../../filters"

export default {
  name: 'ListtingCompare',
  data() {
    return {
      submitting: false,
      listtingCompareTable: 'listtingCompares',
      typeofCompare: null,
      filters: {
        sort: 'created_at:-1',
        include: 'client,carrier,parcel,shipment.invoice,shipment.invoice_fee',
        error_id: -1,
        status: -1
      },
      sorted: {
        created_at: -1
      },
      sorts: [
        { key: 'created_at', name: 'Ngày tạo' }
      ],
      listtingComparesStatus: listtingComparesStatus,
      listtingComparesStatusBg: listtingComparesStatusBg,
      listtingComparesError: listtingComparesError,
      listtingComparesErrorBg: listtingComparesErrorBg,
      shipmentStatuses: shipmentStatuses,
      editModal: false,
      currentListtingCompare: {},
      canEdit: false,
      applyPopup: false,
      removePopup: false,
      addShipmentModal: false,
      uploadUrl: process.env.API_URI + '/cross-checks/update/' + this.$route.params.id,
      uploadHeader: {
        Authorization: `Bearer ${ls.get('authen').access_token}`
      },
      crossChecks: {},
      applyCompareSubmitting: false,
      removeErrorShipmentPopup: false,
      removeErrorShipmentSubmitting: false,
      editShipmentModal: false,
      localShipment: {},
      CROSS_CHECK_TYPE
    }
  },
  computed: {
    ...mapGetters('compare', ['compareHelpers', 'compareFeeHelpers', 'crossChecksHelpers']),
    ...mapGetters('account', ['accountInfo']),
    ...mapGetters('gsTable', ['dataTables']),
    financeReport() {
      return this.crossChecks.finance ? this.crossChecks.finance.data.map($row => {
        return {
          carrier: ($row['short_name']).toUpperCase(),
          cod: vnd($row['carrier_cod']),
          fee: vnd($row['carrier_fee']),
          total_pay: vnd($row['carrier_cod'] - $row['carrier_fee'])
        }
      }) : []
    },
    isCheckUpgrade() {
      return this.crossChecksHelpers && this.accountInfo ? this.crossChecksHelpers.allow_edit_shipments.includes(this.accountInfo.email) : false
    },
    getCrossCheckKind() {
      return (type) => this.crossChecks.kind === type;
    },
    crossCheckConfig() {
      return {
        [CROSS_CHECK_TYPE.COD]: {
          errorSource: () => Object.keys(this.compareHelpers).length ? this.compareHelpers.errors[this.filters.error_id] : '',
          include: 'client,carrier,parcel,shipment.invoice',
        },
        [CROSS_CHECK_TYPE.FEE]: {
          errorSource: () => Object.keys(this.compareFeeHelpers).length ? this.compareFeeHelpers.errors[this.filters.error_id] : '',
          include: 'client,carrier,parcel,shipment.invoice_fee',
        }
      };
    }
  },
  components: {
    DialogAddShipmentToCompare,
    UpgradeShipment
  },
  methods: {
    ...mapActions('compare', ['getCompareHeppers', 'getCompareFeeHeppers', 'getCrossChecksHeppers']),
    removeFilter() {
      if (!this.checkDefaultFilter({
        sort: 'created_at:-1',
        include: 'client,carrier,parcel,shipment.invoice,shipment.invoice_fee',
        error_id: -1,
        status: -1
      })) {
        this.reloadGsTable(this.listtingCompareTable)
      }
      this.filters = {
        sort: 'created_at:-1',
        include: 'client,carrier,parcel,shipment.invoice,shipment.invoice_fee',
        error_id: -1,
        status: -1
      }
      this.setFiltersInclude()
    },
    checkDefaultFilter(filters) {
      let diff = false
      let lkeys = keys(filters)
      forEach(lkeys, key => {
        if (filters[key] !== this.filters[key]) {
          this.diff = true
        }
      })
      return diff
    },
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.listtingCompareTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.listtingCompareTable)
      }
    }, 300),
    editListtingCompare(compare) {
      this.currentListtingCompare = Object.assign({}, compare)
      this.editModal = true
    },
    validateBeforeSubmitEditCompare() {
      this.submitting = true
      this.toggleLoadding(true)
      if (this.currentListtingCompare.cross_check) {
        this.currentListtingCompare.cross_check_id = this.currentListtingCompare.cross_check.data.id
      }
      if (this.crossChecks.kind === CROSS_CHECK_TYPE.FEE) {
        updateCompareFee(this.currentListtingCompare.id, this.currentListtingCompare).then(response => {
          switch (response.code) {
            case 200:
              this.$message({
                type: 'success',
                message: 'Sửa đối soát thành công'
              })
              this.editModal = false
              this.reloadDataListCompare()
              this.toggleLoadding(false)
              this.submitting = false
              break
            case 422:
              let er = response.data.errors
              let message = head(er[Object.keys(er)[0]])
              this.$store.dispatch('showNotify', {
                title: 'Vui lòng kiểm tra thông tin cần nhập',
                body: message,
                type: 'warning'
              })
              this.toggleLoadding(false)
              this.submitting = false
              break
            default:
              this.$message({
                message: 'Sửa đối soát thất bại, vui lòng kiểm tra lại thông tin.',
                type: 'error'
              })
              this.toggleLoadding(false)
              this.submitting = false
          }
        })
      } else {
        updateCompare(this.currentListtingCompare.id, this.currentListtingCompare).then(response => {
          switch (response.code) {
            case 200:
              this.$message({
                type: 'success',
                message: 'Sửa đối soát thành công'
              })
              this.editModal = false
              this.reloadDataListCompare()
              this.toggleLoadding(false)
              this.submitting = false
              break
            case 422:
              let er = response.data.errors
              let message = head(er[Object.keys(er)[0]])
              this.$store.dispatch('showNotify', {
                title: 'Vui lòng kiểm tra thông tin cần nhập',
                body: message,
                type: 'warning'
              })
              this.toggleLoadding(false)
              this.submitting = false
              break
            default:
              this.$message({
                message: 'Sửa đối soát thất bại, vui lòng kiểm tra lại thông tin.',
                type: 'error'
              })
              this.toggleLoadding(false)
              this.submitting = false
          }
        })
      }
    },
    applyCompare() {
      this.applyCompareSubmitting = true
      this.toggleLoadding(true)
      ApplyCrossCheck(this.$route.params.id).then(response => {
        this.applyCompareSubmitting = false
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Xác nhận đối soát thành công!'
          })
          this.reloadGsTableAfterRedirect({ name: 'cross-check' }, 'crossChecks')
          this.toggleLoadding(false)
        } else {
          this.toggleLoadding(false)
          this.$message({
            type: 'error',
            message: response.data.message ? response.data.message : 'Xác nhận đối soát thất bại!'
          })
        }
      })
    },
    removeCompare() {
      this.toggleLoadding(true)
      DeleteCrossCheck(this.$route.params.id).then(response => {
        this.$message({
          type: 'success',
          message: 'Hủy đối soát thành công!'
        })
        this.reloadGsTableAfterRedirect({ name: 'cross-check' }, 'crossChecks')
        this.toggleLoadding(false)
        // if (response.code === 200) {
        //   this.$message({
        //     type: 'success',
        //     message: 'Hủy đối soát thành công!'
        //   })
        //   this.reloadGsTableAfterRedirect({name: 'cross-check'}, 'crossChecks')
        //   this.toggleLoadding(false)
        // } else {
        //   this.$message({
        //     type: 'warning',
        //     message: 'Hủy đối soát thất bại'
        //   })
        // }
      })
    },
    exportExcel() {
      this.toggleLoadding(true)
      let filters = Object.assign({}, this.filters)
      filters.cross_check_id = this.$route.params.id
      if (this.crossChecks.kind === CROSS_CHECK_TYPE.COD) {
        exportExcel(filters).then(response => {
          this.toggleLoadding(false)
          if (response.code == 200) {
            window.location.href = response.full
          }
        }).catch(() => {
          this.toggleLoadding(false)
          this.$message({
            type: 'error',
            message: 'Có lỗi xảy ra khi xuất file, vui lòng thử lại sau hoặc liên hệ quản trị viên!'
          })
        })
      } else if (this.crossChecks.kind === CROSS_CHECK_TYPE.FEE) {
        exportExcelFee(filters).then(response => {
          this.toggleLoadding(false)
          if (response.code == 200) {
            window.location.href = response.full
          }
        }).catch(() => {
          this.toggleLoadding(false)
          this.$message({
            type: 'error',
            message: 'Có lỗi xảy ra khi xuất file, vui lòng thử lại sau hoặc liên hệ quản trị viên!'
          })
        })
      }
    },
    handleUpload(response, file) {
      if (response.code === 200) {
        this.$message({
          type: 'success',
          message: 'Thêm vận đơn vào đối soát thành công!'
        })
        this.reloadDataListCompare()
        this.getCrossCheck({})
      } else {
        this.$message({
          message: 'Thêm đối soát thất bại, vui lòng kiểm tra lại thông tin.',
          type: 'error'
        })
        this.toggleLoadding(false)
      }
    },
    beforeUpload(file) {
      this.toggleLoadding(true)
    },
    deleteListtingCompare(compare) {
      this.$confirm('Bạn chắc chắn muốn xóa đơn khỏi đối soát', 'Xóa đơn đối soát', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Thoát',
        type: 'info'
      }).then(() => {
        this.toggleLoadding(true)
        if (this.crossChecks.kind === CROSS_CHECK_TYPE.COD) {
          deleteCompare(compare.id).then(response => {
            if (response.code === 200) {
              this.reloadDataListCompare()
              this.toggleLoadding(false)
            } else {
              this.toggleLoadding(false)
              this.$message({
                message: 'Xóa đơn đối soát thất bại',
                type: 'error'
              })
            }
          })
        } else if (this.crossChecks.kind === CROSS_CHECK_TYPE.FEE) {
          deleteCompareFee(compare.id).then(response => {
            if (response.code === 200) {
              this.reloadDataListCompare()
              this.toggleLoadding(false)
            } else {
              this.toggleLoadding(false)
              this.$message({
                message: 'Xóa đơn đối soát thất bại',
                type: 'error'
              })
            }
          })
        }

      }).catch(() => {
      })
    },
    reloadDataListCompare() {
      this.reloadGsTable(this.listtingCompareTable)
      this.getCrossCheck({ include: 'finance' })
    },
    removeAllErrorShipment() {
      this.removeErrorShipmentSubmitting = true
      this.removeErrorShipmentPopup = false
      this.toggleLoadding(true)
      removeErrorShipment(this.$route.params.id, { 'error_id': this.filters.error_id }).then(response => {
        this.removeErrorShipmentSubmitting = false
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Xoá tất cả ' + this.getErrorText() + ' thành công!'
          })
          this.reloadDataListCompare()
          this.toggleLoadding(false)
        } else {
          this.toggleLoadding(false)
          this.$message({
            type: 'error',
            message: response.data.message ? response.data.message : 'Xoá tất cả ' + this.getErrorText() + ' thất bại!'
          })
        }
      })
    },
    resyncCode() {
      this.toggleLoadding(true)
      resyncingCode(this.$route.params.id, { 'error_id': this.filters.error_id }).then(response => {
        if (response.status === 'success') {
          this.toggleLoadding(false)
          this.$message({
            type: 'success',
            message: 'Đồng bộ code thành công!'
          })
          this.reloadDataListCompare()
        } else {
          this.toggleLoadding(false)
          this.$message({
            type: 'error',
            message: response.data.message ? response.data.message : 'Đồng bộ code thất bại!'
          })
        }
      }).catch(err => {
        this.toggleLoadding(false)
        this.$message({
            type: 'error',
            message: err.message || 'Kết nối lỗi vui lòng thử lại!'
          })
      })
    },
    updateWeight() {
      this.toggleLoadding(true)
      updateWeight(this.$route.params.id, { 'error_id': this.filters.error_id }).then(response => {
        if (response.status === 'success') {
          this.toggleLoadding(false)
          this.$message({
            type: 'success',
            message: 'Đồng bộ cân thành công!'
          })
          this.reloadDataListCompare()
        } else {
          this.toggleLoadding(false)
          this.$message({
            type: 'error',
            message: response.data.message ? response.data.message : 'Đồng bộ cân thất bại!'
          })
        }
      }).catch(err => {
        this.toggleLoadding(false)
        this.$message({
            type: 'error',
            message: err.message || 'Kết nối lỗi vui lòng thử lại!'
          })
      })
    },
    updateFeeCarrier() {
      this.$confirm('Bạn chắc chắn muốn cập nhật theo phí hãng', 'Cập nhật theo phí hãng', {
        confirmButtonText: 'Xuất & cập nhật phí',
        cancelButtonText: 'Thoát',
        type: 'info'
      }).then(() => {
        getFromUrl(`${this.typeofCompare}${this.$route.params.id}`, { ...this.filters, limit: -1 }).then(response => {
          if (response.code === 200 && response.data.length > 0) {
            this.exportToExcel(response.data)
            this.toggleLoadding(true)
            updateFeeByCarrier(this.$route.params.id, { 'error_id': this.filters.error_id }).then(response => {
              if (response.status === 'success') {
                this.toggleLoadding(false)
                this.$message({
                  type: 'success',
                  message: 'Cập nhật theo phí hãng thành công!'
                })
                this.reloadDataListCompare()
              } else {
                this.toggleLoadding(false)
                this.$message({
                  type: 'error',
                  message: response.data.message ? response.data.message : 'Cập nhật theo phí hãng thất bại!'
                })
              }
            })
          } else {
            this.$message({
              type: 'error',
              message: 'Không có dữ liệu'
            })
          }
        })
      }).catch(() => {
      })
    },
    isOverweight(scope) {
      return parseInt(scope.row.parcel.data.weight) > parseInt(scope.row.parcel.data.real_weight)
        ? scope.row.parcel.data.weight
        : scope.row.parcel.data.real_weight
    },
    verifyCrossCheck() {
      this.toggleLoadding(true)
      verifyCrossCheck(this.$route.params.id, { limit: 1000 }).then(response => {
        if (response.status === 'success') {
          if (response.data.count_update && response.data.count_update > 0) {
            this.verifyCrossCheck()
          } else {
            this.toggleLoadding(false)
            this.crossChecks = response.data
            this.reloadDataListCompare()
            this.$message({
              type: 'success',
              message: 'Duyệt đối soát xong, có ' + this.crossChecks.num_compare_error + ' đơn lỗi trong phiên đối soát này, vui lòng kiểm tra.'
            })
          }
        } else {
          this.toggleLoadding(false)
          this.$message({
            type: 'error',
            message: response.data.message ? response.data.message : 'Duyệt đối soát thất bại!'
          })
        }
      })
    },
    countErrorCompare(errorId) {
      const errorType = this.crossChecks.error_list ? this.crossChecks.error_list.filter(err => err.error == errorId) : []
      return errorType[0] ? errorType[0].count : 0
    },
    closeModalShipment() {
      this.localShipment = {}
    },
    editShipmentSuccess() {
      this.editShipmentModal = false
      this.reloadDataListCompare()
    },
    showEditShipment(shipment) {
      this.localShipment = Object.assign({}, shipment.data)
      this.editShipmentModal = true
    },
    exportToExcel(data) {
      // 1️⃣ Dữ liệu cần xuất

      const formattedData = data.map(item => {
        if (this.crossChecks.kind === CROSS_CHECK_TYPE.COD) {
          return {
            'Mã vận đơn': item.shipment && item.shipment.data.id ? item.shipment.data.id : '',
            'Mã HVC': item.code,
            'Tổng phí đối soát': item.total_fee,
            'Tổng phí vận đơn': item.shipment && item.shipment.data.total_fee ? item.shipment.data.total_fee : 0,
            'Ngày tạo': item.shipment.data.created_at,
            'Ngày giao': item.shipment.data.delivery_at,
            'Ngày chuyển hoàn': item.shipment.data.returned_at
          }
        } else if (this.crossChecks.kind === CROSS_CHECK_TYPE.FEE) {
          let result = item.shipment.data.status_txt
          if (item.shipment.data.is_return) {
            result += ' (Chuyển hoàn)'
          }
          if (item.shipment.data.is_part_delivery) {
            result += ' (Giao một phần)'
          }
          if (item.shipment.data.is_lost) {
            result += ' (Thất lạc)';
          }
          return {
            'Mã HVC': item.code,
            'Tổng phí đối soát lần 1': item.last_total_fee,
            'Tổng phí đối soát': item.total_fee,
            'Chênh lệch': this.differenceFee(item.last_total_fee, item.total_fee),
            'Tổng phí vận đơn': item.shipment && item.shipment.data.total_fee ? item.shipment.data.total_fee : 0,
            'Trạng thái đơn ': result,
            'Ngày tạo': item.shipment.data.created_at,
            'Ngày giao': item.shipment.data.delivery_at,
            'Ngày chuyển hoàn': item.shipment.data.returned_at
          }
        } else if(this.crossChecks.kind === CROSS_CHECK_TYPE.FEE1) {
          return {
            'Mã vận đơn': item.shipment && item.shipment.data.id ? item.shipment.data.id : '',
            'Mã HVC': item.code,
            'Tổng phí đối soát': item.total_fee,
            'Tổng phí vận đơn': item.shipment && item.shipment.data.total_fee ? item.shipment.data.total_fee : 0,
            'Ngày tạo': item.shipment.data.created_at,
            'Ngày giao': item.shipment.data.delivery_at,
            'Ngày chuyển hoàn': item.shipment.data.returned_at
          }
        }
      })

      this.formattedDataExcel(formattedData, this.convertString(this.getErrorText()))
    },
    getCrossCheck(params) {
      getCrossCheck(this.$route.params.id, params).then(response => {
        if (response.code === 200) {
          this.canEdit = !response.data.status
          this.crossChecks = response.data
          switch(this.crossChecks.kind) {
            case CROSS_CHECK_TYPE.COD:
              this.typeofCompare = 'compares/'
              this.filters.include = 'client,carrier,parcel,shipment.invoice'
              break
            case CROSS_CHECK_TYPE.FEE:
              this.typeofCompare = 'compare-fees/'
              this.filters.include = 'client,carrier,parcel,shipment.invoice_fee'
              break
            case CROSS_CHECK_TYPE.FEE1:
              this.typeofCompare = 'compares/'
              this.filters.include = 'client,carrier,parcel,shipment.invoice'
              break
          }
        }
      })
    },
    exportExcelCompare() {
      this.$confirm('Bạn chắc chắn muốn xuất danh sách chưa đối soát lần 1', 'Xuất danh sách đối soát lần 1', {
        confirmButtonText: 'Xuất danh sách',
        cancelButtonText: 'Thoát',
        type: 'info'
      }).then(() => {
        this.toggleLoadding(true)
        getFromUrl(`${this.typeofCompare}${this.$route.params.id}`, { ...this.filters, limit: -1 }).then(response => {
          if (response.code === 200 && response.data.length > 0) {
            // 1️⃣ Dữ liệu cần xuất
            this.exportToExcel(response.data)
            this.toggleLoadding(false)
          } else {
            this.toggleLoadding(false)
            this.$message({
              type: 'error',
              message: 'Không có dữ liệu'
            })
          }
        })
      }).catch(() => {
      })
    },
    formattedDataExcel(formattedData, name) {
      // 2️⃣ Chuyển đổi dữ liệu thành worksheet
      const ws = XLSX.utils.json_to_sheet(formattedData)

      // 3️⃣ Tạo workbook
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Danh sách')

      // 4️⃣ Xuất file Excel
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
      const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' })

      // 5️⃣ Tải file về
      const url = URL.createObjectURL(dataBlob)
      const a = document.createElement('a')
      a.href = url
      a.download = `${name}${this.$route.params.id}.xlsx`
      a.click()
      URL.revokeObjectURL(url)
    },
    getErrorText() {
      const config = this.crossCheckConfig[this.crossChecks.kind];
      return config ? config.errorSource() : '';
    },
    setFiltersInclude() {
      const config = this.crossCheckConfig[this.crossChecks.kind];
      if (config) this.filters.include = config.include;
    },
    convertString(str) {
      return 'danh_sach_' + str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "d").replace(/\s+/g, "_") + '_';
    },
    differenceFee(last_total_fee, total_fee) {
      return total_fee - last_total_fee
    }
  },
  mounted() {
    this.clickToCopy()
    if (ls.get('filters') && ls.get('filters')[this.listtingCompareTable]) {
      this.filters = ls.get('filters')[this.listtingCompareTable]
      setTimeout(() => {
        this.filters.error_id = -1
        ls.set('doFilter', true)
      }, 100)
    }
    if (!Object.keys(this.compareHelpers).length) {
      this.getCompareHeppers()
    }
    if (!Object.keys(this.compareFeeHelpers).length) {
      this.getCompareFeeHeppers()
    }
    if (!Object.keys(this.crossChecksHelpers).length) {
      this.getCrossChecksHeppers()
    }
    this.getCrossCheck({})
    this.listenReloadGsTable()
    this.sorted = this.getSorted(this.listtingCompareTable)
  },
  beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['listtingCompares']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>



// WEBPACK FOOTER //
// ListtingCompare.vue?27366aec